/**
 * Created by Qingger Corp.
 * User: Thinkpad
 * Date: 2019/6/6
 * Time: 16:28
 * Desc: 虚拟店长管理
 */

import { Component, Vue, Watch } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { PolicyTypeText } from '@/views/components/newDistribution/newDistributionList';
import ExportFile from '@/views/components/exportFile';
import { parseSec } from '@/util';

enum StateSotre {
  WAITING, // 待到账
  ENABLE, // 已到账
  DISABLED, // 已失效
  ALL = 9, // 全部
}

@Component({
  components: {
    NoAuth,
    ExportFile,
  },
})
export default class DistributorTransaction extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 商品列表
   * @type {Array<ItemObject>}
   */
  public managerList: Array<GuiderList> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中活动
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 排序名称
   * @type {string}
   */
  public order = '';

  /**
   * 排序方式
   * @type {string}
   */
  public orderBy = '';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 角色标签
   */
  public tagType: number | string = '';

  /**
   * 角色标签列表
   */
  public tagTypeList: ItemArray = [];

  /**
   * 分销类型
   */
  public distributionType: number | string = '';

  /**
   * 分销类型列表
   */
  public distributionTypeList = PolicyTypeText;

  /**
   * 佣金到账状态
   */
  public distributorState: string | number = '';

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;

  /**
   * 佣金到账状态
   */
  public distributorStateList = [
    { label: '全部', value: StateSotre.ALL },
    { label: '待到账', value: StateSotre.WAITING },
    { label: '已到账', value: StateSotre.ENABLE },
    { label: '已失效', value: StateSotre.DISABLED },
  ];

  get exportParams() {
    return {
      exportType: 'vGuiderDetail',
      params: {
        keywords: this.keywords,
        startTime: parseSec(1, this.date[0]) || '',
        endTime: parseSec(2, this.date[1]) || '',
        policyType: this.distributionType === '' ? 9 : this.distributionType,
        tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
        state: this.distributorState === '' ? 9 : this.distributorState,
      },
    };
  }

  /**
   * 分销类型切换
   */
  public distributionTypeChange() {
    this.page = 1;
    this.onGetManagerList();
  }

  /**
   * 角色标签切换
   */
  public tagTypeChange() {
    this.page = 1;
    this.onGetManagerList();
  }

  /**
   * 切换状态
   */
  public distributorStateChange() {
    this.page = 1;
    this.onGetManagerList();
  }

  /**
   * 关键字搜索
   */
  public onSearch() {
    this.page = 1;
    this.onGetManagerList();
  }

  public dateChange() {
    this.page = 1;
    this.onGetManagerList();
  }

  /**
   * 获取角色标签列表
   * @return null
   */
  public getTagList() {
    IPSService.guiderTagList({
      postParams: {
        siteCode: [],
      },
    }).then((response) => {
      this.tagTypeList = response.list;
    });
  }

  /**
   * 获取分销商品列表
   * @return null
   */
  public onSearchVGuiderList(): void {
    this.page = 1;
    this.pageSize = 10;
    this.onGetManagerList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.onGetManagerList();
  }

  /**
   * 页码变更
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.onGetManagerList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
  }

  /**
   * 获取虚拟店长列表
   * @return null
   */
  public onGetManagerList(): void {
    this.managerList = [];
    const postParams = {
      page: this.page,
      pageSize: this.pageSize,
      keywords: this.keywords,
      startTime: parseSec(1, this.date[0]) || '',
      endTime: parseSec(2, this.date[1]) || '',
      policyType: this.distributionType === '' ? 9 : this.distributionType,
      tagName: this.tagTypeList[this.tagType] || '',
      state: this.distributorState === '' ? 9 : this.distributorState,
    };

    IPSService.reportVGuiderDetailList({ postParams }).then((res: ItemObject) => {
      // 格式化数据
      if (res.list.length > 0) {
        res.list.forEach((item) => {
          item.normalOriginPrice = item.normalOriginPrice ? this.moneyRevert(item.normalOriginPrice) : '/';
          item.goodsPrice = item.goodsPrice ? this.moneyRevert(item.goodsPrice) : '/';
          item.profit = item.profit ? this.moneyRevert(item.profit) : '/';
          item.sProfit = item.sProfit ? this.moneyRevert(item.sProfit) : '/';
          item.returnMoney = item.returnMoney ? this.moneyRevert(item.returnMoney) : '/';
          item.goodsPayAmount = item.goodsPayAmount ? this.moneyRevert(item.goodsPayAmount) : '/';
          item.tagName = Functions.emptyVaribleHandler(item.tagName);
          item.orderSn = Functions.emptyVaribleHandler(item.orderSn);
          item.profitFinishTime = Functions.emptyVaribleHandler(item.profitFinishTime);
        });
      }
      this.managerList = res.list;
      this.totalCount = res.count;
    });
  }

  /**
   * 虚拟店长列表排序
   * @param {ItemObject} column
   * @return null
   */
  public onSortChange(column: ItemObject): void {
    this.order = column.prop;
    this.orderBy = column.order === 'ascending' ? 'ASC' : 'DESC';
    this.onGetManagerList();
  }

  moneyRevert(money) {
    return (
      `￥${
        Number(money)
          .toString()
          .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
    );
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-REPORT-V-GUIDER');
    if (this.isContentBodyShow) {
      this.defaultStart = parseSec(3);
      this.defaultEnd = parseSec(4);
      this.date = [this.defaultStart, this.defaultEnd];
      this.onGetManagerList(); // 获取虚拟店长列表
      this.getTagList();
    }
  }
}
